<template>
  <!-- 组织机构 -->
 <div class="treeBigBox app-container">
    <!--树形结构-->
    <div class="box">
      <div class="title">
        <div class="xian"></div>
        <div>组织</div>
      </div>
      <div class="treeBox">
        <el-tree :data="data"
          node-key="id"
          ref="orgTree"
          :props="defaultProps"
          :default-expand-all="true"
          :expand-on-click-node="false"
          :current-node-key="currentData.parentId"
          :highlight-current="true"
          @node-click="handleNodeClick">
        </el-tree>
      </div>
    </div>
    <!--详情标题-->
    <div class="right">
      <div class="title">
        <div class="xian"></div>
        <div>详情</div>
      </div>

      <div>
         <div class="centerBox">
         <div class="rightTop">
            <h4 ref="shangJiName">{{currentData.title}}</h4>
            <el-button type="primary" v-if="btnFlg[0] && currentData.Type !== 5" @click="addClick" >新增</el-button>
         </div>
      <!--详情-->
      <div class="xiangQingBox">
          <!--  表格 -->
        <div class="table" :style="{height:h}">
          <el-table :data="tableList"  ref="table"   v-loading="loading"   bordersize="mini"  @selection-change='selectGoods'
            @row-click="handleRowClick"  height="100%" style="width: 100%" center border class="tableComent">
            <el-table-column type="index" prop="date" width="55" label="序号"></el-table-column>
            <el-table-column label="操作" width="120" >
              <template slot-scope="scope">
                <div>
                  <el-button type="text" size="mini" v-if="btnFlg[1]" @click="editFn(scope.row)">修改</el-button>
                  <el-button type="text" size="mini" v-if="btnFlg[2]" @click="delFn(scope.row)">删除</el-button>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="name" min-width="220"  label="机构名称" :formatter="emptyFn" show-overflow-tooltip></el-table-column>
            <el-table-column prop="orgType" width="150"   label="机构类型" :formatter="statusFormat"></el-table-column>
            <el-table-column prop="code" width="170"   label="机构编码" :formatter="emptyFn"></el-table-column>
            <el-table-column prop="taxpayerNumber"  min-width="220"  label="统一社会信用代码" :formatter="emptyFn"></el-table-column>
            <el-table-column prop="corporationName" label="负责人"  width="150" :formatter="emptyFn"></el-table-column>
            <el-table-column prop="contactsTel" label="联系电话"  width="150" :formatter="emptyFn"></el-table-column>
            <el-table-column prop="createUserName" label="创建人"  width="120" :formatter="emptyFn"></el-table-column>
            <el-table-column prop="createTime" width="170" :formatter="dateTimeFormat"  label="创建时间"></el-table-column>
          </el-table>
        </div>
      </div>
      </div>
      </div>
    </div>
    <!-- 添加机构 -->
    <el-dialog  :title="title1"  :visible.sync="addMark" width="480px" class="detail"  :close-on-click-modal="false" @close="closeDialog" :close-on-press-escape="false" center>
       <el-form :inline="true"  :model="addFrom" ref="addFrom" :rules="rules" class="demo-form-inline jiaoyan" label-width="150px" size="mini">
        <div class="inpBox">
          <div style="margin: 28px 0">
             <el-form-item label="上级机构:" prop="fathername">
              <el-input maxlength="100" v-model.trim="addFrom.fathername" :readonly="true" class="disabled" ></el-input>
              </el-form-item>
              <el-form-item label="机构类型:" prop="orgType">
                <el-select  v-model="addFrom.orgType"  placeholder="请选择" >
                  <el-option
                    v-for="item in agencyType"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                    :disabled="jiGouChange(currentData.Type,item.id)"
                   >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="机构名称:" prop="name">
                <el-input   maxlength="100" placeholder=""   v-model.trim="addFrom.name"></el-input>
              </el-form-item>
              <el-form-item label="统一社会信用代码:" prop="taxpayerNumber" v-if="addFrom.orgType == 2">
                <el-input   placeholder=""   v-model.trim="addFrom.taxpayerNumber"></el-input>
              </el-form-item>
              <el-form-item label="负责人:" prop="corporationName" >
                <el-input  placeholder="" maxlength="15" v-model.trim="addFrom.corporationName"></el-input>
              </el-form-item>
              <el-form-item label="联系电话:" prop="contactsTel">
                <el-input  placeholder="" maxlength="11"  v-number-input.float="0"  v-model.trim="addFrom.contactsTel"></el-input>
              </el-form-item>
          </div>
        </div>
        </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addMark = false">取消</el-button>
        <el-button type="primary" @click="addSave()" v-show="addBtnShow">确定</el-button>
        <el-button type="primary" @click="editSave()" v-show="editBtnShow">修改</el-button>
      </span>
   </el-dialog>
 </div>
</template>

<script>
import {
  organizationTree, // 结构树
  organizationAdd, // 添加
  organizationUpdate, // 修改
  organizationDelete // 删除
} from '@/api/newCrm'
import { getBtn } from '@/utils/getButton'
import { emptyFn, dateTimeFormat, dateFormat } from '@/utils/util'
export default {
  data () {
    return {
      disabled: false,
      currentData: {}, // 当前选中
      addFrom: {},
      dateTimeFormat: dateTimeFormat,
      dateFormat: dateFormat,
      emptyFn: emptyFn,
      tableList: [],
      loading: false,
      title: '',
      title1: '',
      // 组织机构树
      data: [],
      defaultProps: {
        label: 'name',
        children: 'children'
      },
      // 机构类型（ 1.公司，2.子公司，3.部门，4.子部门，5.岗位）
      agencyType: [
        // { name: "请选择", id: ''},
        // { name: "公司", id: '1' },
        { name: '子公司', id: 2 },
        { name: '部门', id: 3 },
        { name: '子部门', id: 4 },
        { name: '岗位', id: 5 }
      ],
      h: '500px',
      // 添加机构
      addMark: false,
      addBtnShow: false,
      editBtnShow: false,
      // 新增验证
      rules: {
        orgType: [
          { required: true, message: '请选择机构类型', trigger: 'blur' }
        ],
        name: [
          { required: true, message: '请输入机构名称', trigger: 'blur' }
        ],
        corporationName: [
          { required: true, message: '请输入负责人', trigger: 'blur' }
        ],
        taxpayerNumber: [
          { required: true, message: '请输入统一社会信用代码', trigger: 'blur' }
        ],
        contactsTel: [
          { required: true, message: '请输入联系电话', trigger: 'blur' },
          this.rule.mobile
        ]
      },
      // 按钮
      btnFlg: [],
      btnIdArr: ['00d00B0100', '00d00B0200', '00d00B0300']
    }
  },
  created () {
    this.getTree(true)
  },
  mounted () {
    let pH = document.documentElement.clientHeight
    this.h = (pH - 235) + 'px'
    this.btnFlg = getBtn(this.btnIdArr)
  },
  methods: {
    // 状态格式化
    statusFormat (row, column, cellValue) {
      switch (cellValue) {
        case 2:
          return '子公司'
        case 3:
          return '部门'
        case 4:
          return '子部门'
        case 5:
          return '岗位'
      }
    },
    // 机构类型下拉框的值改变时触发的事件
    jiGouChange (type, val) {
      // console.log(type);// 添加所选的机构类型
      // console.log(val);// 上级机构的机构类型
      if (type == 3) {
        if (val == 4 || val == 5) {
          return false
        }
        return true
      } else {
        if ((type < val) && (val != 4)) {
          return false
        }
        return true
      }
    },

    // 选择数据
    selectGoods (selection) {
    },
    // 点击选中
    handleRowClick (row, column, event) {
      this.$refs.table.toggleRowSelection(row)
    },

    // 获取左侧菜单
    getTree (flag) {
      organizationTree().then((res) => {
        this.data = res
        if (this.data.length != 0) {
          this.$nextTick(function () {
            console.log(this.$refs.orgTree)
            if (this.$refs.orgTree) {
              this.$refs.orgTree.setCurrentKey(this.currentData.parentId)
              // console.log(this.currentData.parentId + "、、、");
              console.log(this.tableList = this.$refs.orgTree.getNode(this.currentData.parentId).data.children)
              this.tableList = this.$refs.orgTree.getNode(this.currentData.parentId).data.children
            }
          })
          if (flag) {
            this.currentData = {
              title: this.data[0].name,
              Type: this.data[0].orgType,
              tenantCode: this.data[0].tenantCode,
              parentId: this.data[0].id,
              parentCode: this.data[0].code
            }
          }
        }
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    // 点击树
    handleNodeClick (data) {
      this.tableList = data.children
      this.currentData = {
        title: data.name,
        Type: data.orgType,
        tenantCode: data.tenantCode,
        parentId: data.id,
        parentCode: data.code
      }
    },
    // 添加机构
    addClick () {
      this.title1 = '添加机构'
      this.addMark = true
      this.addBtnShow = true
      this.editBtnShow = false
      this.addFrom.fathername = this.$refs.shangJiName.innerHTML
      this.$set(this.addFrom, 'parentId', this.currentData.parentId)
      this.$set(this.addFrom, 'tenantCode', this.currentData.tenantCode)
      this.$set(this.addFrom, 'parentCode', this.currentData.parentCode)
    },
    addSave () {
      this.$refs.addFrom.validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          organizationAdd(this.addFrom).then(res => {
            loading.close()
            this.$message({
              message: '添加成功',
              type: 'success'
            })
            this.addMark = false
            this.getTree()
          }).catch(error => {
            this.$message({
              showClose: true,
              message: error.message,
              type: 'error',
              onClose () {
                loading.close()
              }
            })
          })
        }
      })
    },
    // 修改
    editFn (row) {
      this.title1 = '修改机构'
      this.addBtnShow = false
      this.editBtnShow = true
      this.addMark = true
      this.addFrom = { ...row }
      this.addFrom.fathername = this.$refs.shangJiName.innerHTML
    },
    editSave () {
      this.$refs.addFrom.validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          organizationUpdate(this.addFrom).then(res => {
            loading.close()
            this.$message({
              message: '修改成功',
              type: 'success'
            })
            this.addMark = false
            this.getTree()
          }).catch(error => {
            this.$message({
              showClose: true,
              message: error.message,
              type: 'error',
              onClose () {
                loading.close()
              }
            })
          })
        }
      })
    },
    // 删除
    delFn (row) {
      this.$confirm('是否执行删除操作?', '系统提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        const loading = this.$loading({
          lock: true,
          text: '正在处理...'
        })
        organizationDelete({ id: row.id }).then(res => {
          loading.close()
          this.$message({
            message: '删除成功',
            type: 'success'
          })
          this.getTree()
        }).catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
              loading.close()
            }
          })
        })
      }).catch(() => {

      })
    },
    closeDialog () {
      this.addFrom = {}
      this.$refs['addFrom'].resetFields()
    }

  }
}
</script>

<style scoped lang='less'>
  .treeBigBox{
    display:flex;
  }
  .treeBox{
    text-align: center;
    height: calc(100vh - 164px);
    overflow: auto;
  }
  .centerBox{
    width:100%;
    height:100%;
  }
  .xiangQingBox{
    margin-top: 10px;
  }
 .demo-form-inline .el-form-item{
  margin-bottom: 17px!important;
}
.rightTop{
  display: flex;
  padding: 0 30px;
  align-items: center;
  h4{
    padding-right: 30px;
  }
}
.title{
  width: 100%;
  height: 36px;
  background: #D8E3F8;
  display: flex;
  align-items: center;
  padding-left: 20px;
  box-sizing: border-box;
  font-size: 14px;
  .xian{
    width: 4px;
    height: 16px;
    border-radius: 2px;
    background-color: rgba(11, 79, 214, 100);
    margin-right: 4px;
  }
}
.right{
  // flex: 1;
  // width: 75%;
  width: calc(100% - 361px);
}
.box{
  width: 360px;
  // width:30%;
  border-right: 1px dashed #ddd;
}
/deep/.el-tree-node__content{
  white-space: nowrap;
  overflow:hidden;
  text-overflow:ellipsis;
}
/deep/.inpBox .el-input__inner {
    width: 224px;
}
/deep/.el-tree{
  height: 100%;
}
</style>
